import { useEffect, useState } from "react";
import api from "@/lib/api";
import { WA_PRIMARY, WA_SECONDARY } from "@/data/site";

export const SETTINGS_DEFAULTS = {
    instagram_url: "",
    whatsapp_primary: WA_PRIMARY,
    whatsapp_secondary: WA_SECONDARY,
    contact_email: "",
    cadastur_number: "",
    cadastur_url: "",
};

let cache = null;

/** Configurações públicas do site (números de WhatsApp, Instagram, Cadastur...). Cacheado em módulo. */
export function fetchSiteSettings() {
    if (!cache) {
        cache = api
            .get("/api/settings/public")
            .then(({ data }) => ({ ...SETTINGS_DEFAULTS, ...data }))
            .catch(() => SETTINGS_DEFAULTS);
    }
    return cache;
}

export function clearSettingsCache() {
    cache = null;
}

/** Hook: configurações públicas com fallback imediato para os valores padrão. */
export function useSiteSettings() {
    const [settings, setSettings] = useState(SETTINGS_DEFAULTS);
    useEffect(() => {
        fetchSiteSettings().then(setSettings);
    }, []);
    return settings;
}

/** "5547991624421" → "(47) 99162-4421" */
export function formatPhoneDisplay(digits) {
    const d = (digits || "").replace(/\D/g, "");
    const local = d.startsWith("55") ? d.slice(2) : d;
    if (local.length === 11) return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
    if (local.length === 10) return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
    return digits || "";
}
